import { colors } from '@/theme/colors';
import { SvgIconCommonProps } from './types/svg-icon-common-props';

interface CheckSmallProps extends SvgIconCommonProps {
  variant?: 'default' | 'mqiCheck';
}

export default function CheckSmall({
  className,
  fillPrimary = colors.neutral100,
  variant = 'default',
}: CheckSmallProps) {
  return (
    <svg
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {variant === 'default' ? (
        <path
          d="M3 8.11538L6.66667 11.5L13 4"
          stroke={fillPrimary}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      ) : (
        // MQI check mark
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.5262 1.14987C14.9958 1.44057 15.1408 2.05689 14.8501 2.52648L7.42164 14.5264C7.25317 14.7985 6.96461 14.9736 6.64541 14.9973C6.32622 15.0209 6.01497 14.8904 5.80816 14.6461L1.23679 9.24618C0.879945 8.82466 0.932377 8.19367 1.35389 7.83683C1.77541 7.47999 2.40639 7.53243 2.76323 7.95394L6.44546 12.3036L13.1496 1.47378C13.4403 1.00419 14.0566 0.859177 14.5262 1.14987Z"
          fill={fillPrimary}
        />
      )}
    </svg>
  );
}
